module.exports = __webpack_public_path__ + "static/media/avatar.d6f50b38.png";